import { DateTime } from "luxon";

export function formatJoinedDate(date: string): string {
  const parsed = DateTime.fromISO(date);
  return parsed.isValid ? parsed.toFormat("M/d/yy") : "";
}
